import { MediaResponse } from '@api/backend';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { ErrorResponse } from '@core/models';
import { inject } from '@angular/core';
import { PornRepository } from '@core/repositories/porn.repository';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { debounceTime, distinctUntilChanged, pipe, switchMap, tap } from 'rxjs';
import { tapResponse } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { sessionSelectors } from '@store/session';

type ViewState = {
  view: MediaResponse | null;
  isLoading: boolean;
  error: ErrorResponse | null
};

const initialViewState: ViewState = {
  view: null,
  isLoading: false,
  error: null,
};


export const ViewStore = signalStore(
  { providedIn: 'root' },
  withState(initialViewState),
  withMethods((
    state,
    api = inject(PornRepository),
    globalStore = inject(Store),
  ) => ({
    loadById: rxMethod<{ id?: string }>(
      pipe(
        debounceTime(300),
        distinctUntilChanged(),
        tap(() => patchState(state, { isLoading: true })),
        switchMap(({ id }) => {
          return api.getById(id ?? '').pipe(
            tapResponse({
              next: (view) => patchState(state, { view: view.data }),
              error: () => {},
              finalize: () => patchState(state, { isLoading: false }),
            }),
          );
        }),
      ),
    ),
    trackView: rxMethod<{ id: string, duration: number }>(
      pipe(
        debounceTime(10),
        filter(() => globalStore.selectSignal(sessionSelectors.selectIsSetUser)()),
        distinctUntilChanged(),
        switchMap(({ id, duration }) => api.view(id, { duration })),
      ),
    ),
  })),
);